import { FC } from 'react';
import { SkeletonWrapper } from '~/skeleton/common/skeleton-wrapper';
import { POIInfoSkeleton } from '~/skeleton/poi/component';
import { ArticleCardSkeleton } from '~/skeleton/common/article-card';
import { SkeletonScanline } from '~/skeleton/common/skeleton-scanline';

export const POIFullSkeleton: FC = () => {
  return (
    <SkeletonWrapper>
      <POIInfoSkeleton />
      <ArticleCardSkeleton />
      <ArticleCardSkeleton />
      <SkeletonScanline />
    </SkeletonWrapper>
  );
};

export const POIBodySkeleton: FC = () => {
  return (
    <SkeletonWrapper>
      <ArticleCardSkeleton />
      <ArticleCardSkeleton />
      <SkeletonScanline />
    </SkeletonWrapper>
  );
};
